module.exports = __webpack_public_path__ + "img/galeria-ornamentales-1.e976241a.jpg";